import { GET_SEARCH_HISTORY } from "../actions/types";

const initialState=[]
export default function searchHistory(state = initialState, action) {
    switch (action.type) {
      case GET_SEARCH_HISTORY:
        return action.payload;
      default:
        return state;
    }
  }